// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jfjppoevmfjykflmntgl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpmanBwb2V2bWZqeWtmbG1udGdsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUyNTI1MzksImV4cCI6MjA2MDgyODUzOX0.cdfIqjlL4r7rCG7Hx78wVzqWzEk8vvc8CVd2ucsIGvQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);